import React from 'react';
import PropTypes from 'prop-types';

/**
 *
 *  Populate with the following props :
 *
 *    on_condition : bool
 *    type : 'primary', 'success', 'info', 'warning', 'danger', 'dark'
 *    onClick : function
 *    name : String
 *
 **/

const ToggleSwitch = ({on_condition, type, onClick, name}) => {
  return (
    <div
      className={`switch switch-sm switch-${type || 'success'}`}
      onClick={onClick || null}
      >
  		<div className={`ios-switch ${on_condition ? 'on' : 'off'}`}>
        <div className='on-background background-fill' />
        <div className='state-background background-fill' />
        <div className='handle' />
    	</div>
    </div>
  )
}

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/browser/components/ui/toggle-switch.js